// Free play controls (#46): change the farm live while a free-play session
// runs. Each control calls back into game.js, which owns the shift; this
// module only builds and syncs the panel.

import { ALERT_KINDS } from '../config/constants.js';
import { TRAFFIC_OPTIONS, FREE_MAX_AIRCRAFT } from '../core/freeplay.js';
import { $, setText, setHidden } from './dom.js';

const TRIGGERS = [
  { kind: 'person', icon: '🚶' }, { kind: 'birds', icon: '🐦' }, { kind: 'tower', icon: '🗼' },
  { kind: 'padBlocked', icon: '⛔' }, { kind: 'lowPower', icon: '⚡' },
];

export function createFreePanel(section, handlers) {
  const traffic = $('#fp-traffic', section);
  traffic.innerHTML = TRAFFIC_OPTIONS.map((o) => `<option value="${o.id}">${o.label}</option>`).join('');
  $('#fp-triggers', section).innerHTML = TRIGGERS
    .map((t) => `<button type="button" class="fp-btn fp-icon" data-trigger="${t.kind}" title="Trigger: ${ALERT_KINDS[t.kind].title}" aria-label="Trigger ${ALERT_KINDS[t.kind].title}">${t.icon}</button>`)
    .join('');

  const status = $('#fp-status', section);
  let statusUntil = 0;
  const say = (text) => { setText(status, text); statusUntil = performance.now() + 3500; };

  traffic.addEventListener('change', () => handlers.onSwitch({ traffic: traffic.value }));
  for (const [id, key] of [['#fp-random-alerts', 'randomAlerts'], ['#fp-random-weather', 'randomWeather'], ['#fp-incidents-end', 'incidentsEnd']]) {
    const box = $(id, section);
    box.addEventListener('change', () => handlers.onSwitch({ [key]: box.checked }));
  }
  section.addEventListener('click', (e) => {
    const b = e.target.closest('button');
    if (!b) return;
    if (b.dataset.trigger) say(handlers.onTrigger(b.dataset.trigger));
    else if (b.dataset.add) say(handlers.onAdd(b.dataset.add));
    else if (b.id === 'fp-shuffle') say(handlers.onShuffle());
    else if (b.id === 'fp-deal') say(handlers.onDeal());
    else if (b.id === 'fp-end') handlers.onEnd();
  });

  return {
    /** Show the panel for a free-play shift and match its switches. */
    sync(s) {
      const on = s.shiftKind === 'free';
      setHidden(section, !on);
      if (!on) return;
      const traffic0 = s.trafficEnabled ? s.level : 'off';
      if (traffic.value !== traffic0) traffic.value = traffic0;
      $('#fp-random-alerts', section).checked = s.alerts.random;
      $('#fp-random-weather', section).checked = s.free.randomWeather;
      $('#fp-incidents-end', section).checked = s.free.incidentsEnd;
      const n = s.ops.aircraft.length;
      setText($('#fp-count', section), `${n}/${FREE_MAX_AIRCRAFT}`);
      for (const b of section.querySelectorAll('[data-add]')) b.disabled = n >= FREE_MAX_AIRCRAFT;
      if (performance.now() > statusUntil) setText(status, '');
    },
  };
}
